import { render, staticRenderFns } from "./AlignmentItemsControl.vue?vue&type=template&id=078d1dd2&scoped=true"
import script from "./AlignmentItemsControl.vue?vue&type=script&lang=js"
export * from "./AlignmentItemsControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078d1dd2",
  null
  
)

export default component.exports